module.exports = __webpack_public_path__ + "img/cs4.28e98f2f.png";